import apiClient from "./axios"

export const getAccountVendorPayments = async (params = {}) => {
  const { data } = await apiClient.get("/account-vendor-payments", { params })
  return data
}

export const getAccountVendorPayment = async id => {
  const { data } = await apiClient.get(`/account-vendor-payments/${id}`)
  return data
}

export const createAccountVendorPayment = async payload => {
  const { data } = await apiClient.post("/account-vendor-payments", payload)
  return data
}

export const deleteAccountVendorPayment = async id => {
  const { data } = await apiClient.delete(`/account-vendor-payments/${id}`)
  return data
}
